import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

export const RHFInputFieldMultiline = ({
  name,
  label,
  placeholder,
  rows,
  control,
  validationHelper,
  rules,
  viewMode,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          label={label}
          error={error !== undefined}
          helperText={error ? validationHelper[name][error.type] : ""}
          disabled={viewMode}
          placeholder={placeholder}
          multiline
          rows={rows}
        />
      )}
    />
  );
};
